@if (column.filterable !== undefined && column.filterable !== FilterType.NONE) {
  <div id="filter-header" class="d-flex justify-content-center align-items-center">
    @switch (column.filterable) {
      <!-- RESET ALL FILTER -->
      @case (FilterType.RESET) {
        <div class="reset-filter cursor-pointer rounded-circle d-flex justify-content-center align-items-center" (click)="reset()">
          <mat-icon class="m-b-2" aria-hidden="true">refresh</mat-icon>
        </div>
      }
      <!-- CUSTOM FILTER (e.g. multi-select autocomplete) -->
      @case (FilterType.CUSTOM) {
        @if (column.customTopRow) {
          <ng-container #customTopRowOutlet="ngComponentOutlet"
                        [ngComponentOutlet]="column.customTopRow.component"
                        [ngComponentOutletInputs]="column.customTopRow.inputs" />
        }
      }
      <!-- TEXT / NUMBER / DATE FILTER -->
      @default {
        <mat-form-field appearance="fill" class="w-full" [ngStyle]="{ width: isDate ? '200px' : null }">
          <button mat-icon-button matPrefix [matMenuTriggerFor]="filterMenu" class="d-flex justify-content-center align-items-center current-icon">
            <img [src]="columnFilter.icon" class="m-b-2 object-cover" />
          </button>
          <!-- text and number -->
          @if (!isDate) {
            <input #textFilterInput matInput
                   class="text-[12px]!"
                   [(ngModel)]="filterText"
                   [placeholder]="'search' | translate"
                   (keyup)="onFilterByColumn($event)"
                   (input)="onFilterNonDateChange($event)" />
          } @else {
            <!-- date -->
            <input #dateFilterInput matInput
                   class="text-[12px]!"
                   [matDatepicker]="picker"
                   [readonly]="true"
                   [placeholder]="'search' | translate"
                   (keyup)="onFilterByColumn($event)"
                   (dateChange)="onFilterDateChange()"
                   [(ngModel)]="filterText" />
          }
          @if (isDate) {
            <mat-datepicker-toggle matSuffix [for]="picker" />
          }
          <mat-datepicker #picker [calendarHeaderComponent]="datePickerHeader" />
        </mat-form-field>
        <!-- OPERATOR DROPDOWN LIST -->
        <mat-menu #filterMenu="matMenu" class="cardWithShadow p-0!">
          @for (operator of getOperatorByType(column.filterable); track operator.paramOperator) {
            <button id="filter-item" mat-menu-item
              (click)="onChangeColumnFilter(operator)"
              [ngClass]="{ focusing: isFocusing(operator) }">
              <img [src]="operator.icon" class="object-cover operator-icon p-r-8" />
              <span>{{ operator.name | translate }}</span>
            </button>
          }
          <button id="filter-item" mat-menu-item (click)="clearFilter()">
            <img [src]="'/assets/images/svgs/operators/refresh.svg'" class="object-cover operator-icon p-r-8" />
            <span>{{ "reset" | translate }}</span>
          </button>
        </mat-menu>
      }
    }
  </div>
}
